// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1WLtO","importantInfo":"styles_importantInfo__1zS3H"};